module.exports = ".loading-container {\r\n  padding: 15px 0px;\r\n  display: inline-block;\r\n}\r\n\r\n.signal-message-image {\r\n  max-width: 100px;\r\n  max-height: 80px;\r\n}\r\n\r\n.message-content-cell {\r\n  width: 100%;\r\n  max-height: 134px;\r\n  overflow: hidden;\r\n  display: inline-block;\r\n}\r\n\r\n.message-content-cell img {\r\n      max-width:100px;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tradingstudio/components/styles/signalsMessages.component.css
// module id = ./src/app/tradingstudio/components/styles/signalsMessages.component.css
// module chunks = main